import {
  useListMethodsQuery,
  useListTypesQuery,
} from '../../../../../../../API/order/signingAppointment/SigningAppointmentAPI';
import {
  getSigningTypeOptions,
  ISigningTypeResponse,
} from '../../../../../../../types/signingAppointment/ISigningTypeResponse';
import {
  getSigningMethodDescriptions,
  getSigningMethodOptions,
  ISigningMethodResponse,
} from '../../../../../../../types/signingAppointment/ISigningMethodResponse';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { IDetailsFormData } from '../types/IDetailsFormData';

const emptySigningTypeArray: ISigningTypeResponse[] = [];
const emptySigningMethodsArray: ISigningMethodResponse[] = [];

export const useGetSigningInfoOptions = () => {
  const { data: signingTypes = emptySigningTypeArray } = useListTypesQuery();
  const { data: signingMethods = emptySigningMethodsArray } = useListMethodsQuery();
  const { values } = useFormikContext<IDetailsFormData>();

  const activeMethods: ISigningMethodResponse[] = useMemo(() => {
    return signingMethods.filter((method) => method.isActive);
  }, [signingMethods]);

  const signingTypeOptions = useMemo(() => getSigningTypeOptions(signingTypes), [signingTypes]);
  const methodDescriptions = useMemo(() => getSigningMethodDescriptions(activeMethods), [activeMethods]);
  const signingMethodOptions = useMemo(() => getSigningMethodOptions(activeMethods, values), [activeMethods, values]);

  return {
    signingTypeOptions,
    methodDescriptions,
    signingMethodOptions,
  };
};
